import React from "react";
import { Link } from "gatsby";
import "./index.css";

const isBrowser = typeof window !== "undefined";

const AnnoucementBarHempBan = ({nomargin=false}) => {
  const isProductsListingPage =
    isBrowser &&
    (window.location.pathname === "/products" ||
      window.location.pathname === "/products/");

  return (
    <div
      className={`hemp-ban-announcement-bar ${
        isProductsListingPage ? "hemp-ban-announcement-bar--less-margin" : nomargin ? "hemp-ban-announcement-bar--no-margin" : ""
      }`}
    >
      <Link to="/hemp-ban/" className="hemp-ban-announcement-bar-text">
        <strong>The Hemp Ban Is Already Law:</strong> dates, affected
        products, and your next steps, all in one place &rarr;
      </Link>
    </div>
  );
};

export default AnnoucementBarHempBan;
